import React, { useState } from "react";
import "./DashboardLayout.css";
import { Button } from "react-bootstrap";

/**
 * Re-usable dashboard shell with:
 *  • Fixed 60 px top-bar.
 *  • Collapsible 170 px sidebar.
 *  • Scrollable main content area.
 *
 * Props:
 *  - menuItems   : [{ key: string, label: string }]
 *  - activeKey   : string (currently selected menu key)
 *  - onSelect    : function(key) => void (called when user chooses a menu item)
 *  - children    : JSX (content to render)
 *  - onLogout    : optional callback for logout button
 */
function DashboardLayout({ menuItems, activeKey, onSelect, children, onLogout }) {
  const [isSidebarOpen, setSidebarOpen] = useState(true);

  return (
    <div className="dashboard-container">
      {/* Top navigation bar */}
      <div className="dashboard-topnav">
        <button
          className="hamburger-btn"
          aria-label="Toggle sidebar"
          onClick={() => setSidebarOpen(!isSidebarOpen)}
        >
          &#9776;
        </button>
        {onLogout && (
          <Button className="logout-btn" size="sm" onClick={onLogout}>
            Logout
          </Button>
        )}
      </div>

      {/* Sidebar */}
      <nav className={`dashboard-sidebar ${isSidebarOpen ? "open" : "closed"}`}>
        <ul>
          {menuItems.map((item) => (
            <li
              key={item.key}
              className={activeKey === item.key ? "active" : ""}
              onClick={() => onSelect(item.key)}
            >
              {item.label}
            </li>
          ))}
        </ul>
      </nav>

      {/* Main content area */}
      <div className={`dashboard-main ${isSidebarOpen ? "sidebar-open" : "sidebar-closed"}`}>
        <div className="dashboard-content">{children}</div>
      </div>
    </div>
  );
}

export default DashboardLayout;
